export default "__VITE_ASSET__Chodg6KY__"